<div class="capture-warrant">
  @if (!noJobLeft()) {
    <div class="columns">
      <div class="column pdf-container darkmode-ignore is-6">
        @if (pdfUrl()) {
          <app-pdf-viewer viewerId="JobPdfViewer" [pdfUrl]="pdfUrl()"></app-pdf-viewer>
        }
      </div>

      <form [formGroup]="jobForm" class="column">
        @if (job()?.hidden) {
          <article class="message is-warning">
            <div class="message-body" translate="captureWarrant.hidden"></div>
          </article>
        }

        @if (job() && showIbanCheck()) {
          <app-iban-check
            [newIban]="$safeNavigationMigration(job().newIban?.value)"
            [oldIban]="$safeNavigationMigration(job().oldIban?.value)"
            [id]="job().id"
            [previousJobId]="job().previousJobId"
            (checkSuccess)="ibanCheckSuccess($event)"
          ></app-iban-check>

          <article class="mt-5 panel" [formGroup]="reportForm">
            <p class="has-text-white panel-heading" translate="captureTransaction.detailCheck"></p>
            <div class="panel-block is-flex-direction-column">
              <div class="is-fullwidth mb-2">
                <fino-select
                  [items]="reportPresetItems"
                  formControlName="preset"
                  label="preset"
                  bindLabel="label"
                  bindValue="value"
                >
                  <div *select-item="let item">
                    <div>{{ item.value | translate }}</div>
                  </div>
                </fino-select>
              </div>

              <p translate="captureTransaction.reportDescription"></p>
              <div class="mt-2 is-fullwidth">
                <fino-textarea formControlName="comment" label="comment"> </fino-textarea>
              </div>
              <div class="mt-2 is-justify-content-flex-start is-fullwidth">
                <button [loading]="reportDocumentLoading()" fino-button (click)="reportDocument()">
                  <label class="mr-1" translate="captureTransaction.report"></label>
                </button>
              </div>
            </div>
          </article>
        }

        @if (!showIbanCheck()) {
          <div class="box">
            @if (job()?.oldIban?.value) {
              <h5 class="title is-size-5 mb-1" translate="captureWarrant.oldIban"></h5>
              <p>{{ job().oldIban.value | iban }}</p>
            }

            @if (job()?.newIban?.value) {
              <h5 class="title is-size-5 mb-1 mt-1" translate="captureWarrant.newIban"></h5>
              <p>
                {{ job().newIban.value | iban }}
              </p>
            }
            @if (job()?.oldIban?.value || job()?.newIban?.value) {
              <div class="divider" translate="captureWarrant.IDs"></div>
            }
            <h5 class="title is-size-5 mb-1" translate="captureWarrant.previousJobID"></h5>
            <p>{{ job()?.previousJobId }}</p>
            <h5 class="title is-size-5 mb-1 mt-1" translate="captureWarrant.databaseID"></h5>
            <p>{{ job()?.id }}</p>
          </div>

          <div class="box">
            <h5 class="title is-size-5" translate="captureWarrant.accountOwner"></h5>

            <fino-input
              formControlName="accountOwnerOneFirstName"
              label="firstName"
              validationIndicator
            >
            </fino-input>

            <fino-input
              formControlName="accountOwnerOneLastName"
              label="lastName"
              validationIndicator
            >
            </fino-input>

            @if (hasSecondAccountOwner()) {
              <div>
                <h5 class="title is-size-5" translate="captureWarrant.secondAccountOwner"></h5>

                <fino-input
                  formControlName="accountOwnerTwoFirstName"
                  label="firstName"
                  validationIndicator
                >
                </fino-input>

                <fino-input
                  formControlName="accountOwnerTwoLastName"
                  label="lastName"
                  validationIndicator
                >
                </fino-input>
              </div>
            }

            <button
              class="is-fullwidth"
              (click)="toggleSecondAccountOwner()"
              [primary]="true"
              type="button"
              fino-button
            >
              <p translate="captureWarrant.additionalAccountOwner"></p>
              @if (hasSecondAccountOwner()) {
                <span class="ml-1" translate="captureWarrant.removeAdditionalAccountOwner"></span>
              } @else {
                <span class="ml-1" translate="captureWarrant.addAdditionalAccountOwner"></span>
              }
            </button>
          </div>

          <div class="mb-5">
            @for (field of warrantFields; track field) {
              <div class="box">
                <h5 class="title is-5">
                  {{ 'captureWarrant.' + field.name | translate }}
                </h5>
                <fino-radio-group
                  class="rejectionReason"
                  [values]="field.values"
                  [formControlName]="field.name"
                >
                </fino-radio-group>

                @if (field.name === 'closeAccount' && showAccountClosingDate()) {
                  <fino-input
                    class="mt-2"
                    formControlName="accountClosingDate"
                    label="accountClosingDate"
                    validationIndicator
                  >
                  </fino-input>
                }
              </div>
            }
          </div>

          <form [formGroup]="loadNextDocumentForm" class="mb-2">
            <fino-checkbox formControlName="loadNext" label="captureWarrant.loadNext">
            </fino-checkbox>
          </form>

          <div class="columns mb-2">
            <div class="column">
              <button
                class="is-fullwidth"
                [primary]="true"
                type="submit"
                (click)="submitJob()"
                [disabled]="!jobFormValid"
                [loading]="isSubmitLoading()"
                fino-button
                translate="captureWarrant.submit"
              ></button>
            </div>
          </div>
        }
      </form>
    </div>
  } @else {
    <div class="is-flex is-justify-content-center is-align-items-center is-fullheight">
      <h5 class="title is-size-5" translate="captureWarrant.empty"></h5>
    </div>
  }
</div>
